(function ($, Drupal) {
  'use strict';
  $(document).ready(() => {

    let scrollStartPosition = 0;
    const header = $('header');
    const contentSwitcher = $('#content-switcher');

    // Threshold: Logo bleibt weiss bis 150px gescrollt wurde
    const scrollThreshold = 150;
    // Content-Switcher wird später sticky (wenn Buttons oben ankommen)
    const switcherThreshold = 600;

    let scrollHandler = () => {
      const currentScrollPosition = $(window).scrollTop();

      // Header scrolled state
      if (currentScrollPosition <= scrollThreshold) {
        header.removeClass('scrolled');
        header.removeClass('flat');
        if (currentScrollPosition === 0) {
          return null;
        }
      }
      else {
        header.addClass('scrolled');
      }

      // Content-Switcher scrolled state (später)
      if (currentScrollPosition <= switcherThreshold) {
        contentSwitcher.removeClass('scrolled');
      }
      else {
        contentSwitcher.addClass('scrolled');
      }

      if (scrollStartPosition < currentScrollPosition) {
        header.addClass('flat');
      }
      else {
        header.removeClass('flat');
      }
      scrollStartPosition = currentScrollPosition;
    }

    $(window).scroll(() => scrollHandler());
  })

})(jQuery, Drupal);
